import { mutationWatcher } from '../../observers/mutationObserver.ts';

(function (ng) {
    const domService = function ($document, $window) {
        const service = this;

        function selectorUnpackage(selector) {
            return angular.isElement(selector) && angular.isDefined(selector[0]) ? selector[0] : selector;
        }

        function check(checkList, parent) {
            return checkList.some((selectorItem) =>
                angular.isString(selectorItem) ? service.matches(parent, selectorItem) : parent === selectorItem,
            );
        }

        /**
         * Find parent by selector or Node instance
         * @param {string|Node} element
         * @param {string|Array|Node} selector
         * @param {string|Node} elementLimit
         */

        // TODO переделать на нативный closest
        service.closest = function (element, selector, elementLimit) {
            if (element == null) {
                return null;
            }

            element = angular.isDefined(element[0]) ? element[0] : element;

            const checkList = angular.isArray(selector) ? selector.map(selectorUnpackage) : [selectorUnpackage(selector)];

            let parent = element;

            if (parent == null) {
                return null;
            }
            if (elementLimit != null && typeof elementLimit === 'string') {
                elementLimit = service.closest(element, elementLimit);
            } else {
                elementLimit ||= document.body;
            }

            // oxlint-disable-next-line eqeqeq
            while (parent != elementLimit && parent != document && parent != null) {
                if (check(checkList, parent)) {
                    return parent;
                }

                parent = parent.parentNode;
            }

            return null;
        };

        service.prevAll = function (element) {
            let prevElement,
                result = [];

            element = angular.isDefined(element[0]) ? element[0] : element;

            prevElement = element.previousElementSibling;

            while (prevElement != null) {
                result.push(prevElement);

                prevElement = prevElement.previousElementSibling;
            }

            return result;
        };

        service.nextAll = function (element) {
            let nextElement,
                result = [];

            element = angular.isDefined(element[0]) ? element[0] : element;

            nextElement = element.nextElementSibling;

            while (nextElement != null) {
                result.push(nextElement);

                nextElement = nextElement.nextElementSibling;
            }

            return result;
        };

        service.matches = function (element, selector) {
            const fn =
                Element.prototype.matches ||
                Element.prototype.matchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector;

            return fn.call(element, selector);
        };

        service.parent = function (element, selector, elementLimit) {
            const elementNative = angular.isDefined(element[0]) ? element[0] : element;
            return elementNative.parentElement != null ? service.closest(elementNative.parentNode, selector, elementLimit) : null;
        };

        //modify variant from https://htmldom.dev/get-the-first-scrollable-parent-of-an-element
        service.isScrollable = function (ele) {
            const hasScrollableContent = ele.scrollHeight > ele.clientHeight;

            const overflowYStyle = $window.getComputedStyle(ele).overflowY;
            const isOverflowScroll = ['auto', 'scroll'].some((item) => item === overflowYStyle);

            return hasScrollableContent && isOverflowScroll;
        };

        service.getScrollableParent = function (ele) {
            return !ele || ele === $document[0].body
                ? $document[0].body
                : service.isScrollable(ele)
                  ? ele
                  : service.getScrollableParent(ele.parentNode);
        };

        service.isIos = function () {
            const navigator = $window.navigator;

            return /iPad|iPhone|iPod/u.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        };

        service.isKeyboardOpen = function () {
            const activeElement = $document[0].activeElement;

            return (
                activeElement instanceof $window.HTMLInputElement ||
                activeElement instanceof $window.HTMLTextAreaElement ||
                (activeElement != null && activeElement.isContentEditable === true)
            );
        };

        service.getFocusableField = function (container) {
            const candidates = Array.from(
                container.querySelectorAll(
                    '[autofocus], input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])',
                ),
            ).filter((element) => element.getClientRects().length > 0);

            return candidates.find((element) => element.hasAttribute('autofocus')) ?? candidates[0] ?? null;
        };

        service.focusFirstField = function (container) {
            const field = service.getFocusableField(container);

            if (field == null) {
                return false;
            }

            field.focus({ preventScroll: true });
            return true;
        };

        service.focusFirstFieldOnAppear = function (container, maxWaitMs = 30000) {
            const disconnect = mutationWatcher(container, { childList: true, subtree: true, maxWaitMs }, (observer) => {
                if ($document[0].activeElement !== container) {
                    observer.disconnect();
                    return;
                }

                if (service.focusFirstField(container)) {
                    observer.disconnect();
                }
            });

            return () => disconnect();
        };

        service.restoreFocus = function (target, within) {
            if (target == null) {
                return;
            }

            const doc = $document[0];
            const activeElement = doc.activeElement;

            if (activeElement !== null && activeElement !== doc.body && (within == null || !within.contains(activeElement))) {
                return;
            }

            if (!doc.contains(target) || target.getClientRects().length === 0) {
                return;
            }

            target.focus({ preventScroll: true });
        };
    };

    angular.module('dom').service('domService', ['$document', '$window', domService]);
})(window.angular);
